/**
 * Reporting hook for the links that leave the app for the Myre help site.
 *
 * The header and the footer live here, in a lib every frontend shares, so they
 * cannot depend on an app's analytics layer. An app that wants the numbers
 * provides an implementation; the others inject nothing and report nothing.
 */
export abstract class AbstractHelpAnalyticsService {
  /** The user guide is reachable from the header help menu and from the footer. */
  public abstract trackUserGuideOpened(params: {
    source: 'footer' | 'header';
  }): void;

  public abstract trackReleaseNotesOpened(): void;
}
